import type { EmailProxyDomain } from "@/_store/email-security/email-proxy.module";

export const convertEmailProxyDomainForBE = (data: Partial<EmailProxyDomain>) => {
  return {
    ...data,
    headers: data.headers?.[0].name ? data.headers : [],
  };
};
